import { useMemoizedFn } from "ahooks";

interface CheckAccessClickOptions {
  originClick?: () => void;
}

/**
 * 用于处理需要内测权限的点击事件
 */
export const useCheckAccessClick = (options: CheckAccessClickOptions = {}) => {
  // 用于点击事件的处理函数
  const handleAccessClick = useMemoizedFn(
    async (
      event?: React.MouseEvent | React.SyntheticEvent,
      preventDefault = true,
    ) => {
      // 如果提供了事件对象且需要阻止默认行为
      if (event && preventDefault) {
        event.preventDefault();
      }
      options.originClick?.();
    },
  );

  return {
    handleAccessClick,
  };
};
